// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__eWuOZ","logo":"Loading_logo__tD-Za"};